var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerWindUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.23-60v-60H490v-221.85q-15.08-4.61-27.11-13.23-12.04-8.61-20.66-20.46l-117.15 74L66.54-375v-125h371.61q9.24-13.69 22.39-23.61 13.15-9.93 29.46-14.7v-164.15l195.69-183.23 106.38 66.54-192.3 317.84q12.38 11.62 18.38 30.81 6 19.19 3.16 37.65l140.61 34.39L892-164.85l-88 86.46-245.92-243.77q-1.93 1.16-3.85 1.93-1.92.77-4.23 1.15V-120h70.77v60H419.23ZM180-760v-60h220v60H180Zm370 83.69v138.16q.61 0 .92.3.31.31.93.31L711-800.28l-18-10.03-143 134ZM60-600v-60h180v60H60Zm459.93 203.85q18.61 0 31.26-12.59 12.66-12.59 12.66-31.19 0-18.61-12.59-31.26-12.59-12.66-31.19-12.66-18.61 0-31.26 12.59-12.66 12.59-12.66 31.19 0 18.61 12.59 31.26 12.59 12.66 31.19 12.66ZM314.77-366l103-62.92q-.61-3.08-.61-5.54V-440H126.54v20l188.23 54Zm407.84 19.23-122.46-29.08q-1.23 1.23-2.46 3.08t-2.46 3.08l207.62 207.77 15-14.91-95.24-169.94ZM140-140v-60h180v60H140Zm380-300Zm31.85-97.54ZM417.16-440Zm178.07 70.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerWindUnitIcon);
export default __webpack_public_path__ + "static/media/marker-windUnit-icon.9929d02a885b1f9a29b33bf7a7a1e257.svg";
export { ForwardRef as ReactComponent };